"use client";

import { Suspense, type ReactNode } from "react";

import { SectionErrorBoundary } from "@/shared/ui/section-error-boundary";

type HomeSectionProps = {
  title: string;
  fallback: ReactNode;
  children: ReactNode;
};

export function HomeSection({ title, fallback, children }: HomeSectionProps) {
  return (
    <SectionErrorBoundary sectionTitle={title}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </SectionErrorBoundary>
  );
}
